var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`${_vm.color}--text`},[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])
}
var staticRenderFns = []

export { render, staticRenderFns }